<p-menu #menu [model]="actionMenu" [popup]="true"></p-menu>


<div class="card p-mt-5 p-py-0 p-shadow-2">
    <div class="p-grid p-py-2 p-ai-center p-border-bottom">
        <div class="p-col-10 p-text-primary">
            <h5 class="p-m-0">
                Roles
            </h5>
        </div>
        <div class="p-col-2 p-text-right" [hidden]="!loggedInUser?.editRoles">
            <button class="p-button-secondary"  label="Add Role" pButton
                      (click)="onClickNavigateToUpdateRole('new')"></button>
        </div>
    </div>
    <div *ngIf="roles && !isLoading">
        <div class="p-grid p-ai-center p-py-3" *ngFor="let role of roles?.content, let i = index; let last = last"
             [class.divider-bottom]="!last">
            <div class="p-col-10">
                {{role?.name ? role?.name : '-'}}
            </div>
            <div class="p-col-2 p-text-right">
                <i class="pi pi-ellipsis-v p-text-bold p-text-primary p-cursor" style="font-size: 1.5rem;"
                   (click)="handleToggle($event, role)"></i>
            </div>
        </div>
    </div>


    <div *ngIf="isLoading" class="p-d-flex p-jc-center p-ai-center" style="min-height: 30vh;">
        <div class="p-text-center">
            <div>
                <i class="pi pi-spin pi-spinner p-text-secondary" style="font-size: 2rem;"></i>
            </div>
            <div class="p-mt-3 p-text-secondary">
                Loading Roles !
            </div>
        </div>
    </div>
    <div>
        <p-paginator *ngIf="roles" #pagination [totalRecords]="roles?.totalElements"
                     (onPageChange)="paginateRoles($event)" [rows]="10"></p-paginator>
    </div>
</div>
